/**
 * How a fan is named to a creator (Nicky, 22 Oct 2026): a real first name, or
 * "A fan". Never an email, any part of one, a username or a full name.
 *
 * Account names here are `users.full_name`, which sign-up often fills with
 * the email's local part ("jdoe1987" for jdoe1987@…). So a name is refused
 * when it has an "@" or a digit, or matches a local part of the fan's emails,
 * with or without punctuation. Otherwise the first word is used.
 */
export const FAN_FALLBACK = 'A fan';

export function fanFirstName(
  name: unknown,
  emails: unknown[] = [],
  fallback: string = FAN_FALLBACK
): string {
  const raw = typeof name === 'string' ? name.trim() : '';
  if (!raw || /[@\d]/.test(raw)) return fallback;
  const squash = (s: string) => s.toLowerCase().replace(/[^a-z]/g, '');
  const locals = emails
    .map((e) => (typeof e === 'string' ? e.trim().toLowerCase().split('@')[0] : ''))
    .filter(Boolean);
  if (locals.some((l) => l === raw.toLowerCase() || (squash(l) && squash(l) === squash(raw)))) return fallback;
  const first = raw.split(/\s+/)[0].replace(/^[^\p{L}]+|[^\p{L}'’-]+$/gu, '');
  if (first.length < 2 || first.length > 30) return fallback;
  if (locals.some((l) => l === first.toLowerCase())) return fallback;
  return first;
}
